/**
 * fuzzyMatch - Multi-word search matching
 * Every word in the query must appear somewhere in the text (any order, case-insensitive).
 * 
 * Usage:
 *   fuzzyMatch("mortar net", "1\" Mortar Net") // true
 *   fuzzyMatch("john mason", "Mason John")     // true
 *   fuzzyMatch("xyz", "Mortar Net")            // false
 */
export const fuzzyMatch = (query, text) => {
  if (!query || !text) return false;
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  const target = text.toLowerCase();
  return words.every((w) => target.includes(w));
};
